import { render, staticRenderFns } from "./DateRangeCalendarsPicker.vue?vue&type=template&id=70a8d962&"
import script from "./DateRangeCalendarsPicker.vue?vue&type=script&lang=js&"
export * from "./DateRangeCalendarsPicker.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeCalendarsPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VMenu,VTextField})
